<template>
  <el-button
    class="import-button"
    type="primary"
    icon="el-icon-upload2"
  >
    Import
    <input ref="file" type="file" :accept="accept" @change="onFileChange"/>
  </el-button>
</template>

<script>
import {CancelToken, isCancel} from "axios";

export default {
  name: "import-button",
  props: {
    accept: {
      type: String,
      default: ".xlsx,xls"
    },
    name: {
      type: String,
      default: "file"
    },
    action: String
  },
  data() {
    return {
      axiosCancel: null,
    }
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      this.$refs.file.value = "";
      let acceptReg = this.accept.replace(/\./g, "").replace(/,/g, "|");
      acceptReg = new RegExp(`.(?:${acceptReg })$`, "i");
      if (!acceptReg.test(file.name)) {
        this.$message({
          message: "Only .xlsx,.xls file can be import!",
          type: "warning"
        });
        return;
      }
      const progress = this.$uploadProgress({
        title: "Importing data file...",
        onCancel: () => {
          if (typeof this.axiosCancel === "function") {
            this.axiosCancel();
          }
        }
      });
      const formData = new FormData();
      formData.append("file", file, file.name);
      this.axios.post(this.action, formData, {
        headers: {"Content-Type": "multipart/form-data"},
        cancelToken: new CancelToken(cancel => {
          this.axiosCancel = cancel;
        }),
        onUploadProgress: (e) => {
          if (e.lengthComputable) {
            const percentage = ((e.loaded / e.total) * 100) | 0;
            progress.setPercentage(percentage);
            if (percentage === 100) {
              progress.setTitle("Data processing, please wait...");
            }
          }
        },
      }).then(({code}) => {
        if (200 === code) {
          this.$message({
            message: "Import successfully !",
            type: "success"
          });
          progress.success();
          progress.close();
          this.$emit("success");
        } else {
          this.$message({
            message: "Import failure!",
            type: "error"
          });
          progress.setTitle("Import failure !");
          progress.fail();
        }
      }).catch((err) => {
        progress.setTitle("Import failure !");
        progress.fail();
        if (isCancel(err)) {
          this.axiosCancel = null;
          this.$message({
            message: "Cancel successfully !",
            type: "warning"
          });
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.import-button {
  position: relative;

  input {
    display: block;
    cursor: pointer;
    opacity: 0;
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    span {
      cursor: pointer;
    }
  }
}
</style>